import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import ImageAnimation3 from 'components/layout/loader/ImageAnimation3.jsx';
import { showErrorToast, showSuccessToast } from 'utils/showToast';
import { useUpdateShopWorkingHoursMutation } from '../../../redux/shops/shopsApi';

import {
  Box,
  CancelButton,
  DetailModalInput,
  DetailModalInputWrap,
  DetailModalLabel,
  SaveButton,
  Text,
  Title,
  WrapButton,
} from './WorkingHoursModal.styled'; // можна залишити ті самі стилі

const WorkingHoursModal = ({ onClose, shopId, worksFrom = '', worksTo = '' }) => {
  const [from, setFrom] = useState(worksFrom);
  const [to, setTo] = useState(worksTo);
  const [isDisabled, setIsDisabled] = useState(true);

  const [updateWorkingHours, { isLoading }] =
    useUpdateShopWorkingHoursMutation();

  // ===== Валідація =====
  useEffect(() => {
    if (!from || !to) {
      setIsDisabled(true);
      return;
    }

    setIsDisabled(from >= to);
  }, [from, to]);
const normalizeTime = (time) => time?.slice(0, 5);
  const handleSave = async () => {
    if (isDisabled) return;

    try {
      const response = await updateWorkingHours({
        id: shopId,
     works_from: normalizeTime(from),
      works_to: normalizeTime(to),
      }).unwrap();

      showSuccessToast(response.message || 'Графік роботи оновлено');
      onClose();
    } catch (error) {
      console.error(error);
      showErrorToast(
        error?.data?.message || 'Не вдалося оновити графік роботи'
      );
    }
  };

  return (
    <Modal onClose={onClose}>
      <Box>
        <Title>Графік роботи</Title>

        <Text>
          Вкажіть час початку та завершення роботи магазину.
        </Text>

        <DetailModalLabel htmlFor="worksFrom">
          Працюємо з
        </DetailModalLabel>
        <DetailModalInputWrap>
          <DetailModalInput
            id="worksFrom"
            type="time"
            value={from}
            onChange={e => setFrom(e.target.value)}
          />
        </DetailModalInputWrap>

        <DetailModalLabel htmlFor="worksTo">
          Працюємо до
        </DetailModalLabel>
        <DetailModalInputWrap>
          <DetailModalInput
            id="worksTo"
            type="time"
            value={to}
            onChange={e => setTo(e.target.value)}
          />
        </DetailModalInputWrap>

        <WrapButton>
          <CancelButton onClick={onClose}>
            Скасувати
          </CancelButton>

          {isLoading ? (
            <ImageAnimation3 />
          ) : (
            <SaveButton onClick={handleSave} disabled={isDisabled}>
              Зберегти
            </SaveButton>
          )}
        </WrapButton>
      </Box>
    </Modal>
  );
};

export default WorkingHoursModal;